module.exports = __webpack_public_path__ + "static/img/wys.d912b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wys.png
// module id = qYeh
// module chunks = 1